import { holidayData as holidayDataDE } from './data/de';
import { holidayData as holidayDataDK } from './data/dk';
import { holidayData as holidayDataFI } from './data/fi';
import { holidayData as holidayDataFR } from './data/fr';
import { holidayData as holidayDataIE } from './data/ie';
import { holidayData as holidayDataNO } from './data/no';
import { holidayData as holidayDataSE } from './data/se';
import { holidayData as holidayDataZA } from './data/za';


export function getHolidayData () {
	// Normalize country code (defaults to "se")
	const countryCode = js_params?.countryCode?.toLowerCase?.() || 'se';

	// Otherwise, create the import promise once and store it in holidayDataPromise.
	switch (countryCode) {
		case 'de':
			return holidayDataDE;
		case 'dk':
			return holidayDataDK;
		case 'fi':
			return holidayDataFI;
		case 'fr':
			return holidayDataFR;
		case 'ie':
			return holidayDataIE;
		case 'no':
			return holidayDataNO;
		case 'se':
			return holidayDataSE;
		case 'za':
			return holidayDataZA;
		default:
			return holidayDataSE; // Default to Sweden if no match
	}
}
